import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useSearchParams from "@/hooks/useSearchParams";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Tabs } from "@bookips/solvook-ui-library";
import { styled } from "@mui/material";
import { useRouter } from "next/router";
import React, { useCallback, useEffect, useMemo } from "react";
import { StyledNoticeNew } from "./BrandLNBPc";
import { useBrandStore } from "./BrandProvider";
import { useBrandQuery } from "./queries/useBrandQuery";
import { isPathMatched, normalizePath } from "./checkPath";
const REFERRAL = "referral";
const getActiveLinkPath = (asPath, links, brandName)=>{
    const current = normalizePath(asPath);
    const brandLower = brandName.toLowerCase();
    const matched = links.find((link)=>isPathMatched(current, normalizePath(link.path(brandLower)), link.match));
    return matched === null || matched === void 0 ? void 0 : matched.path(brandLower);
};
export const BrandLNBMobile = (param)=>{
    let { links  } = param;
    const { push , asPath , query  } = useRouter();
    const name = useBrandStore((state)=>state.brand.name);
    const { data: brand  } = useBrandQuery({
        name
    });
    var _brand_hasNewNotice;
    const hasNewNotice = (_brand_hasNewNotice = brand === null || brand === void 0 ? void 0 : brand.hasNewNotice) !== null && _brand_hasNewNotice !== void 0 ? _brand_hasNewNotice : false;
    const searchParams = useSearchParams();
    const activePath = useMemo(()=>getActiveLinkPath(asPath, links, name), [
        asPath,
        links,
        name
    ]);
    const { tabsProps  } = Tabs.useTabs(activePath) //url 필요한
    ;
    const handleChange = useCallback((e, newValue)=>{
        const referral = searchParams.get(REFERRAL);
        if (newValue === activePath && activePath !== asPath) {
            return push(asPath, undefined, {
                shallow: true
            });
        }
        mixpanelEvent("Brand Menu Clicked", {
            "Brand Name": name,
            "Menu Name": newValue
        });
        const newUrl = referral ? "".concat(newValue, "?").concat(REFERRAL, "=").concat(referral) : newValue;
        push(newUrl, undefined, {
            shallow: true
        });
    }, [
        activePath,
        asPath,
        name,
        push
    ]);
    useEffect(()=>{
        if (activePath && activePath !== tabsProps.value) {
            var _tabsProps_onChange;
            (_tabsProps_onChange = tabsProps.onChange) === null || _tabsProps_onChange === void 0 ? void 0 : _tabsProps_onChange.call(tabsProps, undefined, activePath);
        }
    }, [
        activePath
    ]);
    return /*#__PURE__*/ _jsx(MobileLNBContainer, {
        children: /*#__PURE__*/ _jsx(Tabs, {
            ...tabsProps,
            onChange: handleChange,
            size: "sm",
            children: links.map((link)=>/*#__PURE__*/ _jsx(Tabs.Tab, {
                    label: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            link.name,
                            link.name === "공지" && hasNewNotice && /*#__PURE__*/ _jsx(StyledNoticeNew, {})
                        ]
                    }),
                    value: link.path(name),
                    sx: {
                        minWidth: "28px",
                        overflow: "inherit"
                    }
                }, link.index))
        })
    });
};
const MobileLNBContainer = styled("div")((param)=>{
    let { theme  } = param;
    return {
        display: "none",
        backgroundColor: theme.palette.background.paper,
        borderBottom: "1px solid ".concat(theme.palette.divider),
        [theme.breakpoints.down("lg")]: {
            display: "block",
            position: "sticky",
            top: 0,
            zIndex: 2,
            padding: "0 32px"
        },
        [theme.breakpoints.down("sm")]: {
            padding: "0 20px"
        }
    };
});
